import { storageService } from 'framework/utils';
import { useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

export type PositionType = {
  alias: string;
  createdAt: string;
  id: number;
  isLegacy: boolean;
  name: string;
  updatedAt: string;
  vacancyAlias: string;
};

export const PROJECT_MANAGER_ID = 5;
export const BUSINESS_ANALYST_ID = 6;
export const UI_UX_DESIGNER_ID = 8;
export const QA_ENGINEER_ID = 9;
export const SOFTWARE_ENGINEER_ID = 47;
export const CTO_POSITION_ID = 32;
export const EDUCATION_SPECIALIST_ID = 21;

export const isSoftwareEngineerOrEducationalSpecialist = (specialization: string) =>
  String(specialization) === String(SOFTWARE_ENGINEER_ID) || String(specialization) === String(EDUCATION_SPECIALIST_ID);

const usePositionService = () => {
  const { findAll: findAllFromApi } = useBaseCrudService({
    singleResourceUrl: '/positions/:id',
    listResourceUrl: '/positions',
    useService: useKernelApi,
  });

  const { getDataFromStorage } = storageService('positions', findAllFromApi, '1.3');

  const findPositionById = async (id: any): Promise<PositionType> => {
    const positions = await getDataFromStorage();
    return positions.find((position: { id: any }) => position.id === id) || {};
  };

  const findPositionByAlias = async (alias: any): Promise<PositionType> => {
    const positions = await getDataFromStorage();
    return positions.find((position: { alias: any }) => position.alias === alias) || {};
  };

  return {
    findAll: getDataFromStorage,
    findPositionById,
    findPositionByAlias,
  };
};

export default usePositionService;
